import $ from 'jquery'
import 'jquery-migrate'
import './modules/_skip-link-focus-fix'
import './modules/_foundation-scripts'
import './modules/_desktop-menu'
import './modules/_mobile-menu'
import './modules/_galleries'
import { browser } from './modules/_browser-version'
import jump from 'jump.js'

import 'remodal'
import Cookies from 'js-cookie'

/**
 * Notes:
 *
 * Although jQuery is imported above, it is not bundled
 * with the transpiled assets. jQuery needs to be global
 * on the website.
 *
 * All imports belong at the top of the file.
 *
 * Webpack only outputs this one script file, if you need
 * another file then add it to the scripts-list.js file as
 * another line in the scripts_list object.
 *
 * The scripts_list const is imported into the webpack
 * config. I've done this so that you do not have to
 * wade through the config to find what is being
 * compiled out as its own file.
 *
 * When importing node modules that are not ES6 modules,
 * you do not need to path them as '../../node_modules/'.
 * Gulp knows about the node_modules directory, so all you need
 * to do is path them as if you were already in the node_modules
 * directory
 *
 * Instead of:
 * import '../../node_modules/jquery-migrate/dist/jquery-migrate';
 *
 * Use:
 * import 'jquery-migrate/dist/jquery-migrate';
 *
 */

$('html').removeClass('no-js')
$('html').addClass('js')

/*************** Template part region toggle button ***************/
$('#theme_debug_regions').on('click', function (event) {
	event.preventDefault()

	$('.placeHolderPosition').slideToggle()
})

// Give IE user an unoptimized experience.
if (browser.name === 'ie') {
	var script = document.createElement('script')
	script.src = '/wp-content/themes/wp-foundation-six/assets/js/bundle.ie-scripts.js'
	document.getElementsByTagName('head')[0].appendChild(script)
}

/*************** Site Search ***************/
$('.site_search_js').on('click', function (event) {
	event.preventDefault()

	if ($('.site-search-form').hasClass('site-search-form--active')) {
		$('.site-search-form').removeClass('site-search-form--active')
		$('.site_search_js').trigger('focus')
	} else {
		$('.site-search-form').addClass('site-search-form--active')
		$('.site_search_field').trigger('focus')
	}
})

/*************** Anchor scroll ***************/
$('a[href*=#]:not(.tabs a)').on('click', function (event) {
	//only execute this script if anchor link is on same page
	if (this.pathname === window.location.pathname) {
		event.preventDefault()

		const anchor_to = $(this).attr('href')

		if (!$(anchor_to).length) {
			return
		}

		jump(anchor_to, {
			offset: -100,
		})
	}
})

/*************** Back to top ***************/
$(window).on('scroll', function () {
	if ($(window).scrollTop() >= 100) {
		$('.back-to-top').addClass('back-to-top--show')
	} else {
		$('.back-to-top').removeClass('back-to-top--show')
	}
})

/*************** News Posts Filtering ***************/
$('#category').on('change', function () {
	var url = $(this).val() // get selected value
	if (url) {
		// require a URL
		window.location = url // redirect
	}
	return false
})

/*************** Format UMC Sidebar Block output if only one nested menu ***************/
jQuery(document).ready(function () {
	if ($('.umc-sidebar__menu .sub-menu > li').find('ul').length == 0) {
		//console.log('did not find a submenu', $('.sub-menu > li').find('ul').length)
		$('.sub-menu').addClass('single-submenu')
	}
})

/*************** Add css class to first CTA button on specific UMC service pages ***************/

const ctaServicePages = [
	'/services/cancer-care/',
	'/services/cardiac-care/',
	'/services/emergency-care/',
	'/services/emergency-care/emergency-care-services-and-programs/burn-care/',
	'/services/gastroenterology/',
	'/services/kidney-transplant/',
	'/services/maternity-newborn/',
	'/services/orthopaedic-care/',
	'/services/neurosurgery/',
	'/services/radiology/',
	'/services/senior-services/',
	'/services/weight-loss/',
]

const currentPage = window.location.pathname

if (ctaServicePages.includes(currentPage)) {
	const ctaNav = document.querySelector('[id^="umc-call-to-action-block_"]') // selects the id of the cta nav
	const ctaButton = ctaNav.querySelector('a') // selects the first cta button
	ctaButton.classList.add('cta-button-standout') // add css class
}

/*************** Open modal Window ***************/
var inst = $('[data-remodal-id=alert-notice-modal]').remodal({
	hashTracking: false,
	// closeOnOutsideClick: false,
})

/**
 * Opens the modal window
 */
if (!Cookies.get('alert-notice-modal')) {
	if (inst) {
		inst.open()
	}
}

$(document).on('closed', '.alert-notice-modal', function () {
	Cookies.set('alert-notice-modal', 'closed', { expires: 1, path: '/' })
})
